/** fileName: LazyLoading.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import React, {Children, useEffect, useRef, useState} from "react";
import {Grid} from "@mui/material";
import EmptyList from "../emptyList/EmptyList";
import useId from "@mui/material/utils/useId";
import {useInView} from "framer-motion";

const LazyLoading = ({fetchNextPage, hasNextPage = true, maxHeight = 'auto',padding='16px', children,loadingTxt='در حال بارگذاری... لطفا صبر کنید', ...props}) => {
    const [renderDone, setRenderDone] = useState(false)
    const arrayChildren = Children.toArray(children);
    const id = useId();
    // before return
    const ref = useRef(null)
    // const isVisible = useOnScreen(ref)
    const isVisible = useInView(ref)
    // console.log('isvisible:',isVisible,', rednder done:',renderDone)

    useEffect(() => {

        if (isVisible && renderDone) {
            setRenderDone(false);
            if (hasNextPage)
                fetchNextPage();
        }
    }, [isVisible, renderDone]);

    useEffect(() => {
        if (!isVisible)
            setTimeout(() => {
                setRenderDone(true);
            }, 1000)
    }, [isVisible])


    return (
        <>
            <Grid item id={"lazy-" + id} sx={{maxHeight: maxHeight, overflowX: 'hidden', overflowY: 'scroll'}}
                  display={"flex"}
                  flexDirection={"row"}
                  padding={padding}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  {...props}
            >

                {children}
                {arrayChildren[0]?.props?.children?.length === 0 && <EmptyList/>}
                {
                    // hasNextPage &&
                    <div style={{
                        visibility: hasNextPage ? 'visible' : 'hidden',
                        width: '100%',
                        marginTop: 24,
                        height: 24,
                        textAlign: 'center',
                        backgroundColor: '#dcde9f',
                        color: '#696969'
                    }} ref={ref}>
                        {loadingTxt}
                    </div>
                }
                <div style={{height: 30, width: '100%', backgroundColor: 'transparent'}}/>

            </Grid>

        </>

    )
}
export default LazyLoading
